import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import ko from 'knockout';
import 'devexpress-reporting/dx-webdocumentviewer';
import '@devexpress/analytics-core/dist/css/dx-analytics.common.css';
import '@devexpress/analytics-core/dist/css/dx-analytics.light.css';
import 'devexpress-reporting/dist/css/dx-webdocumentviewer.css';

/**
 * DevExpress Web Document Viewer component.
 * Displays XtraReports directly in the browser with full interactivity
 * (zoom, print, export, page navigation, search).
 *
 * Usage:
 *   <ReportViewer reportName="TestReport" />
 *   <ReportViewer reportName="WMR0047" />
 *
 * Props:
 *   - reportName: The name/URL of the report registered in ReportStorageWebExtension
 *   - width: CSS width (default: '100%')
 *   - height: CSS height (default: '100%')
 */
const ReportViewer = ({ reportName, width = '100%', height = '100%', oidc }) => {
    const viewerRef = useRef(null);
    const koApplied = useRef(false);

    useEffect(() => {
        if (!viewerRef.current || !reportName) return;

        // Build the backend API base URL (strip the /api suffix for DXXRDV route)
        const apiBase = window._env_.REACT_APP_APIS;
        // The DevExpress Document Viewer controller default route is "DXXRDV"
        // We need to point to: {apiBase}/DXXRDV  (or {baseWithoutApi}/DXXRDV)
        const handlerUri = apiBase.endsWith('/api')
            ? apiBase.substring(0, apiBase.length - 4) + '/DXXRDV'
            : apiBase + '/DXXRDV';

        const viewerModel = {
            reportUrl: ko.observable(reportName),
            requestOptions: {
                host: '',
                invokeAction: handlerUri
            }
        };

        // Clean up any previous binding
        if (koApplied.current) {
            ko.cleanNode(viewerRef.current);
        }

        ko.applyBindings(viewerModel, viewerRef.current);
        koApplied.current = true;

        return () => {
            if (viewerRef.current && koApplied.current) {
                ko.cleanNode(viewerRef.current);
                koApplied.current = false;
            }
        };
    }, [reportName]);

    return (
        <div
            ref={viewerRef}
            data-bind="dxReportViewer: $data"
            style={{ width, height }}
        />
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(ReportViewer);

